import Cookies from "js-cookie";

export default function getUserInfo() {
    const userInfo = Cookies.get('user_info');
    if(!userInfo){
        return  null;
    }
    return JSON.parse(userInfo);
}

